import phpdoc from "refractor/phpdoc";
export default phpdoc;